module.exports = __webpack_public_path__ + "assets/autotest1.jpg?8aa5b73111cce5ce214c8a82822aeac6";